import { TableStaticActions } from '@billy/design-system'
import { ReactElement } from 'react'

import { TransactionOriginatorType } from '@features/transactions/enums/transactionOriginatorType'

import { useTransactionStaticActions } from '../../hooks/useTransactionStaticActions'

interface TransactionsTableStaticActionsProps {
  isVoided?: boolean
  originatorId: string
  originatorType?: TransactionOriginatorType
  transactionId: string
}

export const TransactionsTableStaticActions = ({
  isVoided,
  originatorId,
  originatorType,
  transactionId,
}: TransactionsTableStaticActionsProps): ReactElement => {
  const { handleSelect, items, modals } = useTransactionStaticActions({
    isVoided,
    originatorId,
    originatorType,
    transactionId,
  })

  return (
    <>
      <TableStaticActions items={items} onSelect={handleSelect} />
      {modals}
    </>
  )
}
